/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UrlOperationResponse
 */
export interface UrlOperationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UrlOperationResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {string}
     * @memberof UrlOperationResponse
     */
    errorMessage?: string;
    /**
     * Temporary URL to access the file
     * @type {string}
     * @memberof UrlOperationResponse
     */
    url?: string;
}

/**
 * Check if a given object implements the UrlOperationResponse interface.
 */
export function instanceOfUrlOperationResponse(value: object): value is UrlOperationResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    return true;
}

export function UrlOperationResponseFromJSON(json: any): UrlOperationResponse {
    return UrlOperationResponseFromJSONTyped(json, false);
}

export function UrlOperationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UrlOperationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function UrlOperationResponseToJSON(json: any): UrlOperationResponse {
    return UrlOperationResponseToJSONTyped(json, false);
}

export function UrlOperationResponseToJSONTyped(value?: UrlOperationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'url': value['url'],
    };
}

